import lazyRetry from './lazyLoader';
import { Navigate, useParams, Outlet } from 'react-router-dom';
import Lazy from 'components/Lazy.tsx';
import { lazy } from 'react';

const FlowView = Lazy(lazy(() => lazyRetry(() => import('views/flow/FlowView'))));

const ProjectRedirect = () => {
  const { projectId, workflowId } = useParams();
  return <Navigate to={`/projects/${projectId}/workflows/${workflowId}/canvas`} replace />;
};

const ProjectCanvasRoutes = {
  path: '/projects/:projectId/workflows/:workflowId',
  element: <Outlet />,
  children: [
    {
      index: true,
      element: <ProjectRedirect />,
    },
    {
      path: 'canvas',
      element: <FlowView />,
      children: [
        {
          path: 'revision/:workflowRevision',
        },
        {
          path: 'revision/:workflowRevision/executions/:workflowExecutionId',
        },
      ],
    },
  ],
};

export default ProjectCanvasRoutes;
